var map = {
	"./collage-0.avif": 32110,
	"./collage-1.avif": 60833,
	"./collage-1029w-0.avif": 84006,
	"./collage-2.avif": 93700,
	"./collage-3.avif": 9431,
	"./collage-4.avif": 61394,
	"./collage-503w-2.avif": 14272,
	"./collage-503w-4.avif": 64038
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52667;